<template>
  <div>
    <v-select
      v-model="selectedContactId"
      :items="contacts"
      clearable
      item-value="id"
      v-bind="{ ...inputProps }"
      :label="
        $t(
          'wallet:billingContacts.manageContact.selectFromContacts.label',
          'Select from my contacts'
        )
      "
      outlined
    >
      <template #item="{ item }">
        <AppShowContactName :contact="item" />
      </template>

      <template #selection="{ item }">
        <AppShowContactName :contact="item" />
      </template>
    </v-select>
  </div>
</template>
<script>
import { defineComponent, computed } from "vue";
import { clone } from "lodash-es";
import AppShowContactName from "@AppShows/AppShowContactName.vue";

export default defineComponent({
  name: "AppSelectContact",
  components: {
    AppShowContactName
  },
  props: {
    inputProps: {
      type: Object,
      default: () => ({})
    },
    basedOnContactId: {
      type: String,
      default: null
    },
    contacts: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  emits: ["update:basedOnContactId"],
  setup(props, ctx) {
    const selectedContactId = computed({
      get() {
        return props.basedOnContactId;
      },
      set(value) {
        ctx.emit("update:basedOnContactId", value);
        if (value) {
          const contact = clone(props.contacts.find(x => x.id == value));
          delete contact.id;
          contact.basedOnContactId = value;
          ctx.emit("selected-contact", contact);
        } else {
          ctx.emit("selected-contact", null);
        }
      }
    });

    return {
      selectedContactId
    };
  }
});
</script>
